(function ($, undefined) {
    'use strict';
    var formValidator;
    var utils;
    var toast;
    var hubspot;

    var enableEditBoxContent = function () {
        var btn = $(this);
        var box = btn.closest('.my-infos-form-box');

        box.addClass('has-processing_active my-infos-form-box_editing');
        box.find('input, select').removeAttr('readonly');
        box.find('.form-checkbox-ctn').removeClass('readonly');

        if (box.find('.input-password__input').length > 0) {
            box.find('.input-password__input').attr('placeholder', '');
        }

        btn.fadeOut(function () {
            box.find('.my-infos-form-box__actions-unlocked').fadeIn();
            box.removeClass('has-processing_active');
        });
    };

    var disableEditBoxContent = function () {
        var btn = $(this);
        var box = btn.closest('.my-infos-form-box');

        resetBox(box);
    };

    var resetBox = function (box) {
        box.addClass('has-processing_active');
        box.removeClass('my-infos-form-box_editing');
        box.find('input[type="text"], input[type="email"], select').each(function () {
            $(this).val($(this).attr('data-value'));
            $(this).trigger('keyup');
            if ($(this).attr('name') !== 'province' || ($(this).attr('name') === 'province' && $(this).closest('.select-state-input-ctn').hasClass('selected'))) {
                $(this).trigger('change');
            }
        });
        box.find('input[type="checkbox"]').each(function () {
            if ($(this).attr('data-value') === 'true' && !$(this).prop('checked')) {
                $(this).trigger('click');
            }
        });
        box.find('.form-message').slideUp();
        box.find('input, select').attr('readonly', 'readonly').removeClass('error');
        box.find('.form-checkbox-ctn').addClass('readonly');

        if (box.find('.input-password__input').length > 0) {
            box.find('.input-password__input').attr('placeholder', '• • • • • • • • • • • •');
        }

        box.find('.my-infos-form-box__actions-unlocked').fadeOut(function () {
            box.find('.my-infos-form-box__edit-btn').fadeIn();
            box.removeClass('has-processing_active');
        });
    };

    var updateDatabindedEl = function () {
        var input = $(this);
        var databindedEl = $('.js-databinded-el[data-id="' + input.attr('name') + '"]');
        var newVal = input.val();

        if (input.attr('name') === 'country') {
            newVal = input.find('option[value="' + input.val() + '"]').text();
            input.closest('.my-infos-form-box').find('.select-state-input-ctn.selected select').trigger('change');
        }

        databindedEl.text(newVal);

        if (databindedEl.hasClass('js-handle-sep')) {
            var ctn = databindedEl.closest('p');

            if (ctn.children().eq(0).text().length === 0 || ctn.children().eq(2).text().length === 0) {
                ctn.find('.person-recap__text-sep').fadeOut();
            } else {
                ctn.find('.person-recap__text-sep').fadeIn();
            }
        }

        if (input.attr('type') === 'email') {
            databindedEl.attr('href', 'mailto:' + newVal);
        }
    };

    Object.size = function (obj) {
        var size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key))
                size++;
        }
        return size;
    };

    var saveBoxInfo = function () {
        var btn = $(this);
        var box = btn.closest('.my-infos-form-box');
        var form = btn.closest('.my-informations__form');
        var errorMsg = box.find('.error-occured');
        var data = {
            userId: box.attr('data-person-id'),
            ajax: true
        };
        // var initialDataSize = Object.size(data);

        formValidator.validateForm(box);
        errorMsg.slideUp();

        if (!box.hasClass('has-error')) {
            var pass = true;
            var phone = box.find("input[name = 'phoneNumber']");
            if (phone.length !== 0) {
                pass = chkPhoneNumber(phone.val());
                if (pass) {
                    phone.val(sanitizePhone(phone.val()));
                    phone.removeClass('error');
                    box.find('.my-informations__phone-error-message').slideUp();
                } else {
                    phone.addClass('error');
                    box.find('.my-informations__phone-error-message').slideDown();
                }
            }

            if (pass) {
                box.addClass('has-processing_active');
                utils.appendDataToSubmit(form, data);


                // edit only if new data
                // if (Object.size(data) > initialDataSize) {
                $.ajax({
                    url: '/action/pmiAccount',
                    type: 'POST',
                    data: data,
                    cache: false,
                    complete: ({ responseText }) => {
//						console.log({ responseText });
                        if (responseText.indexOf('success') > -1) {
                            form.find(box).each(function () {
                                var b = $(this);
                                b.find('input[type="text"], input[type="email"], select').each(function () {
                                    $(this).attr('data-value', $(this).val());
                                });
                                b.find('input[type="checkbox"]').each(function () {
                                    $(this).attr('data-value', $(this).is(':checked'));
                                });
                                resetBox(b);

                                var hasOptInCheckboxes = $('[name=newsletter2]', box).length > 0;
                                if (hasOptInCheckboxes) {
                                    hubspot.toggleOptInsHubspotByContactEmail(data.email,
                                            $('[name=newsletter2]', box).is(":checked"),
                                            $('[name=newsletter_cbx]', box).is(":checked"));
                                }
                            });
                        } else {
                            errorMsg.slideDown();
                            box.removeClass('has-processing_active');
                    }
                    }
                });
                // } else {
                // 	resetBox(box);
                // }
            }
        }
    };

    var showToastOnLoggedIn = function () {
        if ($('.my-account').length > 0 && location.search.indexOf("login") !== -1) {
            toast.create(
                    document.documentElement.lang === 'fr' ? "Vous avez été connecté! " : "You were logged in!",
                    toast.DURATION.MEDIUM,
                    "success"
                    );
        }
    };


    var init = function () {
        utils = Fw.component.models().utils;
        formValidator = Fw.component.models().form;
        toast = Fw.component.models().toast;
        hubspot = Fw.component.models().hubspot;

        $('.my-infos-form-box__edit-btn').click(enableEditBoxContent);
        $('.my-infos-form-box__cancel-btn').click(disableEditBoxContent);
        $('input.js-databind').keyup(updateDatabindedEl);
        $('select.js-databind').change(updateDatabindedEl);
        $('.my-infos-form-box__save-btn').click(saveBoxInfo);

        showToastOnLoggedIn();
    };

    $(window).ready(function () {
        init();
    });
})(jQuery);
